import { useState, useEffect } from "react";

function GiftCard({ gift }) {
  const [btnHovered, setBtnHovered] = useState(false);

  return (
    <div className="brg-card">
      {gift.badge && <span className="brg-badge">{gift.badge}</span>}
      <span className="brg-tag">{gift.tag}</span>
      <p className="brg-label">{gift.label}</p>
      <div className="brg-price">₹{gift.price}</div>
      <a href={`/products?id=${gift.sub_id}`}>
  <button
    className="brg-btn"
    onMouseEnter={() => setBtnHovered(true)}
    onMouseLeave={() => setBtnHovered(false)}
  >
    Shop Now
    <span className="brg-btn-arrow">→</span>
  </button>
</a>
    </div>
  );
}

export default function BudgetReturnGifts() {
  const [gifts, setGifts] = useState([]); // initialize as empty array
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBanners = async () => {
    try {
      const res = await fetch(
        "https://api.welbeing.in/home/combo/"
      );
      const data = await res.json();
      // console.log(data.data);
      if (data.status === "success") setGifts(data.data);
      else throw new Error("Failed to fetch banners");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  if (loading) return <p>Loading gifts...</p>;
  if (error) return null;

  return (
    <div className="brg-section">
      <div className="brg-header">
        <span className="brg-eyebrow">Curated Collections</span>
        <h2 className="brg-title">
          Budget Return <span>Gifts</span>
        </h2>
        <p className="brg-subtitle">
          Thoughtful gifts for every budget — from sweet gestures to grand impressions.
        </p>
      </div>
      <div className="brg-grid">
        {gifts.map((gift) => (
          <GiftCard key={gift.id} gift={gift} />
        ))}
      </div>
    </div>
  );
}